var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.014,
    height: 16.015,
    viewBox: "0 0 16.014 16.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7734",
    transform: "translate(-0.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7721",
    transform: "translate(0.016 3.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7720",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    d: "M8.023 132.475v-6.107c-.173.016-.344.043-.518.051H2.518a.5.5 0 0 0-.5.5v.5H.516a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.5v.5a.5.5 0 0 0 .5.5h.3l2.012 5.363a1 1 0 0 0 .737.623.98.98 0 0 0 .9-.275l1.2-1.192a1 1 0 0 0 .184-1.158l-1.679-3.36h1.339c.173.012.343.039.514.055z",
    fill: "currentColor",
    transform: "translate(-0.016 -126.368)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7723",
    transform: "translate(9.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    d: "M294.94.242a.356.356 0 0 0-.032-.042.494.494 0 0 0-.209-.16s-.005-.005-.008-.006h-.029a.5.5 0 0 0-.14-.028.464.464 0 0 0-.1.02.553.553 0 0 0-.056.011.5.5 0 0 0-.219.142s-.01.005-.014.009a10.531 10.531 0 0 1-6.119 3.626v6.4a10.53 10.53 0 0 1 6.119 3.625c0 .005.011.007.016.013a.485.485 0 0 0 .124.1c.015.009.027.022.042.029a.515.515 0 0 0 .2.044.523.523 0 0 0 .169-.029s.005-.005.008-.006a.487.487 0 0 0 .209-.16l.032-.047a.484.484 0 0 0 .082-.258V.5a.484.484 0 0 0-.075-.258z",
    fill: "currentColor",
    transform: "translate(-288.016)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.96495bda.svg";
export { ForwardRef as ReactComponent };